import { MatchGroup } from "types/entities/Match";

export const createRows = (matchGroups: MatchGroup[]): (MatchGroup & { key: number })[] => {
  return matchGroups.map(matchGroup => ({ ...matchGroup, key: matchGroup.group_id }));
}
